// extracted by mini-css-extract-plugin
export default {"container":"Freeswitch_container__p+UeS","containerInner":"Freeswitch_containerInner__HoYUJ","header":"Freeswitch_header__a5ce+"};